import { render, staticRenderFns } from "./BulkUpdateFaceInfoDialog.vue?vue&type=template&id=4db1c5ea&"
import script from "./BulkUpdateFaceInfoDialog.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateFaceInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports